module.exports = __webpack_public_path__ + "img/台阶.87ee95b9.png";